/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum FeatureFlag {
    FEATURE_YOY_MIGRATION_ENABLED = 'feature_yoy_migration_enabled',
    QUICKSIGHT_AUTHORING_ENABLED = 'quicksight_authoring_enabled',
    DATA_MANAGEMENT = 'data_management',
    DATA_MANAGEMENT_V2 = 'data_management_v2',
    SIMPLIFIED_RANGE_ELIGIBILITY_ENABLED = 'simplified_range_eligibility_enabled',
    SURVEY_ORCHESTRATION_CUSTOMER_SURVEY_DOWNLOAD = 'survey_orchestration_customer_survey_download',
    LEVEL_MAPPING_GLOBAL_GRADES_TO_GLOBAL_LEVEL = 'level_mapping_global_grades_to_global_level',
    TENANCY_MANAGEMENT = 'tenancy_management',
    COMPOSITE_ACCESS_RANGE_MODELING = 'composite_access_range_modeling',
    SELF_SERVICE_PARTICIPATION_TEMPLATE_FIELD_MAPPING = 'self_service_participation_template_field_mapping',
    JOB_DESCRIPTION_IN_COMPOSITES = 'job_description_in_composites',
}
